

const autocompleteServices = {};

const noBounds = new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng( 26.068891917543485, 56.15335399793324 ),
    new window.google.maps.LatLng( 22.649991491808834, 55.17808607984964 )
);

const options = {
    bounds: noBounds,
    types: [ 'geocode' ],
    //Added just US results
    componentRestrictions:{country: 'AE'}
};

const AddressAutocomplete = {

    initAutocomplete( inputName, inputField, callback ) {

        autocompleteServices[inputName] = new window.google.maps.places.Autocomplete( inputField, options );

        autocompleteServices[inputName].addListener( 'place_changed', callback.bind( null, autocompleteServices[inputName] ) );

    },

    getCityAndState( addressComponents ) {
        // info to check against
        const componentData = {
            locality: 'long_name',
            sublocality_level_1: 'long_name',
            administrative_area_level_1: 'short_name'
        };
        // create object which will hold information
        const cityAndState = {};
        addressComponents.forEach( component => {
            let componentType;
            const componentTypes = component.types;

            componentTypes.forEach(element => {
               if(componentData[element]) {
                componentType = element;
               } 
            });

            if ( componentData[componentType] ) {
                if ( componentType === 'locality' || componentType === 'sublocality_level_1' ) {
                    cityAndState.city = component.long_name;
                } else {
                    cityAndState.state = component.short_name;
                }
            }
        });

        if(cityAndState.city === undefined){
            cityAndState.city = "";
        }
        console.log(cityAndState, "cityAndState");
        // return city and state data
        return cityAndState;
    }
}



export default AddressAutocomplete;



// WEBPACK FOOTER //
// ./src/common/AddressAutocomplete.js